export default __webpack_public_path__ + "static/media/payoutHeaderImg.784ee875.png";